class ForgotPasswordConfig {

    static initRoute ($stateProvider) {
        'ngInject';
        $stateProvider.state('public.users.forgot-password', {
          url: "/forgot-password",
          template: require("./forgot-password.html"),
          controller: "ForgotPasswordUsersController as forgotpassword"
        }).state('public.users.forgot-email', {
          url: "/forgot-email",
          template: require("./forgot-email.html"),
          controller: "ForgotEmailUsersController as forgotemail"
        }).state('public.users.password-reset', {
          url: "/password-reset",
          template: require("./password-reset.html"),
          controller: "PasswordResetUsersController as passwordreset"
        }).state('public.users.password-reset-sent', {
          url: "/password-reset-sent",
          params : {
            login : null
          },
          template: require("./password-reset-sent.html"),
          controller: "PasswordResetSentUsersController as passwordresetsent"
        }).state('public.users.password-reset-sent2', {
          url: "/password-reset-sent2",
          template: require("./password-reset-sent2.html"),
          controller: "PasswordResetSent2UsersController as passwordresetsent2"
        }).state('public.users.new-password', {
          url: "/new-password?email&token&lang",
          template: require("./new-password.html"),
          controller: "NewPasswordUsersController as newpassword"
        }).state('public.users.password-changed', {
          url: "/password-changed",
          params : {
            email : null
          },
          template: require("./password-changed.html"),
          controller: "PasswordChangedUsersController as passwordchanged"
        }).state('public.users.choose-account', {
          url: "/choose-account",
          template: require("./choose-account.html"),
          controller: "ChooseAccountUsersController as chooseaccount"
        }).state('public.users.account-confirmation', {
          url: "/account-confirmation",
          template: require("./account-confirmation.html"),
          controller: "AccountConfirmationUsersController as accountconfirmation"
        }).state('public.users.recovery-account-login', {
          url: "/recovery-account-login",
          template: require("./recovery-account-login.html"),
          controller: "RecoveryAccountLoginUsersController as recoveryaccountlogin"
        }).state('public.users.no-account', {
          url: "/no-account",
          template: require("./no-account.html"),
          controller: "NoAccountUsersController as noaccount"
        });
    }
}

export default ForgotPasswordConfig.initRoute;



// WEBPACK FOOTER //
// ./src/users/forgot-password/forgot-password.config.js